export const presaleAddress = "0xa8ab6b251f83b0e234b80f8d3a3b93d01f0facf8";
export const stakingAddress = "0x0092e03f676d449fe4d13ec1976a7ba5c7577ed5";
export const tokenAddress = "0x546582e4652eb46c759032ad0b96969e5bb22d5d";
